import React, {useEffect, useState, useRef} from "react"
import {IconContext} from "react-icons/lib"
import {RxRadiobutton} from "react-icons/rx"
import {CgRadioCheck} from "react-icons/cg"
import {LuClock1} from "react-icons/lu"
import {translateConstants} from "../../../services/translationService"
import {timeZones} from "@murphy-frontend/web-core/constants"
import {useUserPreferences} from "../../../contexts/UserPreferencesContext"
import {TimeZoneType} from "@murphy-frontend/common/services/TimeService"
import {IoChevronDown, IoChevronUp} from "react-icons/io5"

const TimezoneDropdown = () => {
	const [showTimezone, setShowTimezone] = useState(false)
	const listRef = useRef<HTMLLIElement>(null)

	const {timeZone, language, setTimeZone} = useUserPreferences()

	const handleClickInside = () => {
		setShowTimezone(true)
	}

	function handleClickOutside(e: MouseEvent) {
		if (!listRef.current.contains(e.target as HTMLInputElement)) {
			setShowTimezone(false)
		}
	}

	useEffect(() => {
		document.addEventListener("click", handleClickOutside)
		return () => document.removeEventListener("click", handleClickOutside)
	}, [])

	const onChangeTimeZone = (id: TimeZoneType) => {
		setTimeZone(id)
	}

	return (
		<li className={"sidebar-settings-list"} ref={listRef} onClick={handleClickInside}>
			<div className='sidebar-text-wrapper'>
				<div className='sidebar-link sidebar-link-nested sidebar-link'>
					<IconContext.Provider value={{className: "sidebar-icon"}}>
						<LuClock1 />
					</IconContext.Provider>
					<div className='sidebar-text'>Timezone</div>
				</div>
				<IconContext.Provider value={{className: "sidebar-icon"}}>
					{showTimezone ? <IoChevronUp /> : <IoChevronDown />}
				</IconContext.Provider>
			</div>
			{showTimezone && (
				<ul className={"sidebar-settings-list-nested"}>
					{translateConstants(language, timeZones).map(el => (
						<li
							className='sidebar-settings-radio'
							onClick={() => onChangeTimeZone(el.id.toString())}
							key={el.id}
						>
							<IconContext.Provider value={{className: "sidebar-icon"}}>
								{el.id.toString() === timeZone ? <RxRadiobutton /> : <CgRadioCheck />}
							</IconContext.Provider>
							{el.value}
						</li>
					))}
				</ul>
			)}
		</li>
	)
}

export default TimezoneDropdown
